import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

const getHistory = () => history;

export default getHistory;
